import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrderListConfigService } from 'gung-standard';

@Component({
    selector: 'app-hl-display-order-list-wrapper',
    templateUrl: './hl-display-order-list-wrapper.component.html',
    styleUrls: ['./hl-display-order-list-wrapper.component.css'],
    standalone: false
})
export class HlDisplayOrderListWrapperComponent {
  constructor(public orderListConfigService: OrderListConfigService, route: ActivatedRoute) {
    const customerId = route.snapshot.params.customerId;

    if (customerId != null) {
      orderListConfigService.setCustomerId(customerId);
    } else {
      orderListConfigService.setCustomerId(null);
    }
  }
}
